/* eslint-disable import/no-unresolved */
import { graphql, useStaticQuery } from 'gatsby'

const vacatureInfo = {
  get() {
    const { 
      wordpressPage
     } = useStaticQuery(graphql`
      {
        wordpressPage(wordpress_id: {eq: 847}) {
          path

          acf {
            meta {
              text_read_message
            }
          }
        }
      }
    `)
  
    return wordpressPage
  }
}

export default vacatureInfo